import { observable } from "mobx";
import { Type } from "class-transformer";
import DeadLetterTopicMessageResponse from "./deadLetterTopicMessageResponse";
import PaginationResponse from "./paginationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DeadLetterTopicMessagesSearchResponse {
  @observable
  @Type(() => PaginationResponse)
  metadata!: PaginationResponse;

  @observable
  @Type(() => DeadLetterTopicMessageResponse)
  items!: DeadLetterTopicMessageResponse[];
}
